import { createSlice } from '@reduxjs/toolkit';

export const envSlice = createSlice({
  name: 'env',
  initialState: {
    ORCHESTRATOR_HOST: '',
    requestID: '',
    API_KEY: '',
  },
  reducers: {},
  selectors: {
    selectHost: state => state.ORCHESTRATOR_HOST,
    selectApiKey: state => state.API_KEY,
  },
});
